module.exports = __webpack_public_path__ + "img/8.75ee70e5.jpeg";